import { giphyAqua, giphyBlue, giphyGreen, giphyIndigo, giphyPurple, giphyRed, giphyYellow } from '@giphy/js-brand'
import { ReactNode, useMemo } from 'react'
import { Gradient } from 'types'
import { iconComponent } from 'ui/src/types/icons'
import { csvToHexArray, gradientToHexColors, normalizeHexLength } from 'utils'
import { ColorPicker, Colors, HexInput, Panel, SwatchButton, Swatches } from './style'

const CheckmarkIcon = iconComponent('checkmark-circle')

const COLORS: string[] = [
    '#ffffff',
    '#000000',
    giphyRed,
    giphyYellow,
    giphyGreen,
    giphyAqua,
    giphyBlue,
    giphyIndigo,
    giphyPurple,
]
const GRADIENTS: Gradient[] = ['red-yellow', 'blue-green', 'indigo-purple']

type Props = {
    className?: string
    color?: string
    swatchLabel?: ReactNode
    onChange?: (color: string) => void
}

const ColorPanel = ({ className, color, swatchLabel, onChange }: Props) => {
    const activeColors = useMemo(() => csvToHexArray(color || ''), [color])
    const activeGradient = useMemo(() => {
        return GRADIENTS.find((gradient) => gradientToHexColors(gradient).join(',') === color)
    }, [color])

    const onHexChange = (value: string) => {
        const colors = csvToHexArray(value)

        if (colors.length) {
            onChange?.(colors.join(','))
        }
    }

    const onGradientClick = (gradient: Gradient) => {
        onChange?.(gradientToHexColors(gradient).join(','))
    }

    return (
        <Panel className={className}>
            <Colors>
                {swatchLabel}
                <Swatches>
                    {COLORS.map((swatch) => (
                        <SwatchButton
                            color={swatch}
                            size="small"
                            key={`uge-color-swatch-${swatch}`}
                            onClick={() => onChange?.(swatch)}
                        >
                            {normalizeHexLength(swatch) === normalizeHexLength(color || '') && <CheckmarkIcon />}
                        </SwatchButton>
                    ))}
                    {GRADIENTS.map((swatch) => (
                        <SwatchButton
                            color={gradientToHexColors(swatch)[0]}
                            gradient={swatch}
                            key={`uge-color-swatch-${swatch}`}
                            size="small"
                            onClick={() => onGradientClick(swatch)}
                        >
                            {swatch === activeGradient && <CheckmarkIcon />}
                        </SwatchButton>
                    ))}
                    <HexInput format="color" placeholder={color || '#hex'} onChange={onHexChange} />
                </Swatches>
            </Colors>
            <ColorPicker color={activeColors[0]} disabled={activeColors.length > 1} onChange={onChange} />
        </Panel>
    )
}

export default ColorPanel
